<template>
  <div class="logo-cards">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'LogoCards'
  }
</script>

<style lang="scss">
  .logo-cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 16px;

    @media (max-width: $breakpoint-lg) {
      grid-template-columns: auto;
      grid-gap: 8px;
    }
  }
</style>